import axios from "axios";
import { errorHandeling } from "../errorHandeling";
import { useState } from "react";
import { useSelector } from "react-redux";
import apiUrl from "../libs/baseUrl";

function useVacationsWaiting() {

const token = useSelector(state => state.user.token);    
//===State start here===
const [vacationsArr,setVacationsArr] = useState([])
const [loadingResult,setLoadingResult] = useState(false)
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);

const [error,setError] = useState(null)
//===State end here===

//===Event handler start here===    
const fetchVacations = async (page = currentPage , searchValue ) => {

   let url;
        
   if (searchValue && searchValue !==0 && searchValue.trim() !== "") {
    url = `${apiUrl}/vacations/waiting/get/${searchValue}`;
   }
   else{
     url = `${apiUrl}/vacations/waiting/get`;
   }   


  try {
    setLoadingResult(true);
    const response = await axios.get(
      url,
   
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params : {
          page : page ,
        }
      }
    );
    setVacationsArr(response.data.data.data);
    setCurrentPage(response.data.data.current_page);
    setTotalPages(response.data.data.last_page);
    setLoadingResult(false);
  } catch (error) {
    console.error('Error:', error);
    setLoadingResult(false);
    setError(errorHandeling(error));
  }
};

//===Event handler end here===  
  return { fetchVacations , vacationsArr , loadingResult , currentPage , totalPages , error };
}

export default useVacationsWaiting;